// L'onglet Hermès de la fiche d'une personnalité suivie (16 octobre 2026).
// Jamais de genre deviné : le nom, ou « cette personnalité ».
export default {
  nouvelle: 'Nouvelle conversation',
  conversations: 'Vos conversations',
  lecture: 'Lecture…',
  aucune: 'Vos conversations avec Hermès sur cette personnalité apparaîtront ici.',
  seRelit: 'Hermès relit la conversation…',
  titre: 'Hermès, sur {qui}',
  texte: 'Hermès, l’assistant politique d’Orion, connaît le dossier : ce qui se dit chaque jour, les citations tracées, les positions, ceux qui en parlent. Demandez-lui d’écrire, de riposter ou d’analyser.',
  departs: {
    tweet: 'Écris trois tweets qui génèrent du clic pour annoncer une prise de parole de {qui}.',
    riposte: 'Prépare une riposte à l’attaque la plus reprise cette semaine.',
    faiblesses: 'Quels sont ses trois points faibles dans l’opinion en ce moment, et comment les retourner ?',
    tiktok: 'Écris un script TikTok de trente secondes pour toucher les moins de trente ans.',
  },
}
